export function activationPostcodeOptions(step3 = {}) {
  const targets = Array.isArray(step3.selectedPostcodeTargets) ? step3.selectedPostcodeTargets : []
  if (targets.length > 0) {
    return targets
      .filter((target) => target?.id && target?.postcode)
      .map((target) => ({ id: target.id, postcode: target.postcode }))
  }

  return (step3.selectedPostcodes ?? [])
    .filter(Boolean)
    .map((postcode) => ({ id: postcode, postcode }))
}
